import { render, staticRenderFns } from "./FormForgotPassword.vue?vue&type=template&id=0e317f80&"
import script from "./FormForgotPassword.vue?vue&type=script&lang=js&"
export * from "./FormForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports